import { updateLastInRow } from './updateLastInRow.js'
export function animateTab() {
  const commonElement = document.querySelectorAll('.animate-tabs')
  commonElement.forEach(target => {
    const tabs = target.querySelectorAll('.animate-tabs__btn')
    const contents = target.querySelectorAll('.animate-tabs__content')

    const activateTab = (tabId) => {
      tabs.forEach(tab => tab.classList.remove('animate-tabs__btn--active'))
      contents.forEach(content => content.classList.remove('animate-tabs__content--active'))

      const selectedTab = target.querySelector(`[data-tab="${tabId}"]`)
      const selectedContent = target.querySelectorAll(`[data-tab-content="${tabId}"]`)
      selectedContent.forEach(content => {
        content.style.display = 'flex'
        requestAnimationFrame(() => {
          content.classList.add('animate-tabs__content--active')
          updateLastInRow()
        })
      })

      selectedTab.classList.add('animate-tabs__btn--active')
      setTimeout(() => {
        selectedContent.forEach(content => content.classList.add('animate-tabs__content--active'))
      }, 50)

    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const tabId = tab.dataset.tab
        activateTab(tabId, tab)
      })
    })
  })

}
